module.exports = __webpack_public_path__ + "img/pass-icon-open.0c9b8763.svg";